export interface ArticleLink {
  title: string;
  slug: string;
  description: string;
  category: string;
}

export const articleLinks: ArticleLink[] = [
  {
    title: 'Kakobuy Spreadsheet Guide - How It Works & Getting Started',
    slug: 'kakobuy-spreadsheet-guide',
    description: 'A complete beginner-friendly walkthrough explaining what Kakobuy Spreadsheet is, how to use it effectively, and tips for finding the best products quickly.',
    category: 'Guide',
  },
  {
    title: 'Best Kakobuy Finds 2026 - Updated Product Spreadsheet Collection',
    slug: 'best-kakobuy-finds',
    description: 'Explore our curated collection of the most popular Kakobuy product finds, trending items, and community-recommended discoveries across all major shopping categories.',
    category: 'Discoveries',
  },
  {
    title: 'Kakobuy vs CSSBuy vs Superbuy - Complete Comparison Guide',
    slug: 'kakobuy-vs-alternatives',
    description: 'An in-depth comparison of the most popular shopping spreadsheet platforms, covering features, product variety, ease of use, and which one suits your needs best.',
    category: 'Comparison',
  },
  {
    title: 'Kakobuy Shopping Safety - Tips, Red Flags & Best Practices',
    slug: 'kakobuy-shopping-safety',
    description: 'Essential safety guidelines for using product spreadsheets and shopping platforms. Learn how to verify sellers, protect your payments, and avoid common pitfalls.',
    category: 'Safety',
  },
  {
    title: 'Complete Kakobuy Beginner Guide - Start Finding Products Today',
    slug: 'kakobuy-beginner-guide',
    description: 'New to product spreadsheets? This step-by-step guide walks you through everything from setting up to making your first successful purchase using organized product lists.',
    category: 'Guide',
  },
  {
    title: 'CSSBuy Spreadsheet Guide - Fashion Finds, Streetwear & Shopping Tips',
    slug: 'cssbuy-spreadsheet-guide',
    description: 'Discover curated fashion and streetwear finds on CSSBuy. Learn how CSSBuy spreadsheets work, compare fees and shipping, and find the best clothing picks.',
    category: 'Guide',
  },
  {
    title: 'Superbuy Spreadsheet Guide - Product Range, Tools & Shopping Strategy',
    slug: 'superbuy-spreadsheet-guide',
    description: 'Explore the widest product catalog on Superbuy. Learn shipping tools, inspection features, fee structures, and strategies for maximizing your shopping experience.',
    category: 'Guide',
  },
  {
    title: 'Oopbuy Spreadsheet Guide - Trending Finds, Niche Products & Early Access',
    slug: 'oopbuy-spreadsheet-guide',
    description: 'Discover trending and niche products before they hit mainstream. Learn Oopbuy fees, shipping, and explore unique finds with expert curation tips.',
    category: 'Guide',
  },
  {
    title: 'Kakobuy Fashion Spreadsheet - Best Clothing Finds, Trends & Style Guide',
    slug: 'kakobuy-fashion-spreadsheet',
    description: 'Curated clothing finds across hoodies, jackets, pants, and accessories. Compare trends, prices, and quality with expert style recommendations.',
    category: 'Discoveries',
  },
  {
    title: 'Kakobuy Sneaker Spreadsheet - Top Footwear Finds, Releases & Buying Guide',
    slug: 'kakobuy-sneaker-spreadsheet',
    description: 'Curated footwear finds including retro runners, basketball sneakers, and casual shoes. Compare prices, quality scores, and community ratings.',
    category: 'Discoveries',
  },
];